import styled from 'styled-components';
import goverment from 'images/common/goverment.png';

export const Wrapper = styled.div`
  background: url(${goverment}) no-repeat center 0;
  background-position: bottom;
  background-color: #f9f9f9;
  height: 250px;
  @media (max-width: 560px){
    height: 300px;
    background-size: cover;
  }
`;

export const WrapperContent = styled.ul`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 250px;


  @media (max-width: 768px) {
    flex-direction: column;
  }
  li:last-child h2{
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
  }
  li h4:nth-of-type(1){
    @media (max-width: 768px){
      padding-top: 15px;
    }
  }

  li {
    width: 33%;

    @media (max-width: 768px){
      width: 100%;
      justify-content: center;
    }

    &:nth-child(2) {
      text-align: center;
    }
  }
  li h2, h3, h4 {
    @media (max-width: 768px){
      text-align: center;
    }
  }
  h3 {
    @media (max-width: 768px){
      padding-top: 20px;

    }
  }
  li a img {
    @media (max-width: 768px){
      padding: 15px 0 0 15px;
      width: 80px;
    }
  }
  h4 {
    margin-top: 10px;
    color: #d20000;

    @media (max-width: 768px) {
      font-size: 14px;
      margin-top: 3px;
    }
}
  h2, h3 {

    span {
      color: #5f6c77;
      font-size: 26px;
    }
    @media (max-width: 768px){
      font-size: 20px;
    }
  }


  h2{
    @media (max-width: 768px) {
      font-size: 24px;

      @media (max-width: 768px) {
        font-size: 20px;
    }
    span {
      @media (max-width: 768px){
        font-size: 20px;
      }
      @media (max-width: 768px){
        font-size: 15px;
      }
    }
  }

`;



// WEBPACK FOOTER //
// ./src/system/information/components.js